export default __webpack_public_path__ + "static/media/Plattform_Reflection.98b2f793.jpg";